module.exports = __webpack_public_path__ + "static/media/lecture_edit.40da1d5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/liveroom/lecture_edit.png
// module id = 1948
// module chunks = 6